<template>
    <table class="table table-bordered p-2">
        <thead>
            <th>Dato</th>
            <th>Valor (Dotted Decimal)</th>
            <th>Valor (Binario)</th>
        </thead>
        <tbody>
            <tr>
                <th>IP</th>
                <td>{{ ipaddress }}</td>
                <td class="text-monospace">{{ ipaddressbin }}</td>
            </tr>
            <tr>
                <th>Clase Teórica</th>
                <td>{{ ipclass }}</td>
                <td>N/A</td>
            </tr>
            <tr>
                <th>Máscara</th>
                <td>{{ ipmask }} / {{ ipmaskcidr}} </td>
                <td class="text-monospace">{{ ipmaskbin }}</td>
            </tr>
            <tr>
                <th>Dirección de Red</th>
                <td>{{ ipnetaddr }}</td>
                <td class="text-monospace">{{ ipnetaddrbin }}</td>
            </tr>
            <tr>
                <th>Primera IP</th>
                <td>{{ ipnetfirst }}</td>
                <td class="text-monospace">{{ ipnetfirstbin }}</td>
            </tr>
            <tr>
                <th>Ultima IP</th>
                <td>{{ ipnetlast }}</td>
                <td class="text-monospace">{{ ipnetlastbin }}</td>
            </tr>
            <tr>
                <th>Broadcast</th>
                <td>{{ ipnetbcast }}</td>
                <td class="text-monospace">{{ ipnetbcastbin }}</td>
            </tr>
            <tr>
                <th>Equipos</th>
                <td>{{ ipnethosts }}</td>
                <td class="text-monospace">N/A</td>
            </tr>
        </tbody>
    </table>
</template>

<script>
import iputils from "../lib/iputils";

export default {
    props: ["ipaddress", "ipmaskcidr"],
    computed: {
        ipclass: function() {
            return iputils.getClassFromIP(this.ipaddress);
        },
        ipaddressbin: function ()  {
            return iputils.isValidIP(this.ipaddress) ?
                iputils.stringToBinary(this.ipaddress) :
                '';
        },
        ipmask: function () {
            return iputils.isValidIP(this.ipaddress) ?
                iputils.getCIDRSubnet(this.ipaddress, this.ipmaskcidr).subnetMask :
            '';
        },
        ipmaskbin: function() {
            return iputils.isValidIP(this.ipaddress) ?
                iputils.stringToBinary(this.ipmask) :
                '';
        },
        ipnetaddr: function() {
            return (iputils.isNetIPClass(this.ipclass)) ?
                iputils.getCIDRSubnet(this.ipaddress, this.ipmaskcidr).networkAddress :
                '';
        },
        ipnetaddrbin: function() {
            return (iputils.isNetIPClass(this.ipclass)) ?
                iputils.stringToBinary(this.ipnetaddr) :
                '';
        },
        ipnetfirst: function() {
            return (iputils.isNetIPClass(this.ipclass)) ?
                iputils.getCIDRSubnet(this.ipaddress, this.ipmaskcidr).firstAddress :
                '';
        },
        ipnetfirstbin: function() {
            return (iputils.isNetIPClass(this.ipclass)) ?
                iputils.stringToBinary(this.ipnetfirst):
                '';
        },
        ipnetlast: function() {
            return (iputils.isNetIPClass(this.ipclass)) ?
                iputils.getCIDRSubnet(this.ipaddress, this.ipmaskcidr).lastAddress :
                '';
        },
        ipnetlastbin: function() {
            return (iputils.isNetIPClass(this.ipclass)) ?
                iputils.stringToBinary(this.ipnetlast) :
                '';
        },
        ipnetbcast: function() {
            return (iputils.isNetIPClass(this.ipclass)) ?
                iputils.getCIDRSubnet(this.ipaddress, this.ipmaskcidr).broadcastAddress :
                '';
        },
        ipnetbcastbin: function() {
            return (iputils.isNetIPClass(this.ipclass)) ?
                iputils.stringToBinary(this.ipnetbcast) :
                '';
        },
        ipnethosts: function () {
            return (iputils.isNetIPClass(this.ipclass)) ?
                iputils.getMaskSubnet(this.ipaddress, this.ipmask).numHosts :
                '';
        }        
    }
}
</script>